var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHsdCardLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44857 21.606H9.49097V14H6.44857V21.606ZM18.509 21.606H21.5514V6.394H18.509V21.606ZM12.4788 21.606H15.5212V17.0424H12.4788V21.606ZM12.4788 14H15.5212V10.9576H12.4788V14ZM3.46074 28C2.50282 28 1.68655 27.6627 1.01193 26.9881C0.33731 26.3134 0 25.4972 0 24.5393V3.46074C0 2.50282 0.33731 1.68655 1.01193 1.01193C1.68655 0.33731 2.50282 0 3.46074 0H24.5393C25.4972 0 26.3134 0.33731 26.9881 1.01193C27.6627 1.68655 28 2.50282 28 3.46074V24.5393C28 25.4972 27.6627 26.3134 26.9881 26.9881C26.3134 27.6627 25.4972 28 24.5393 28H3.46074Z",
    fill: "#005587"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHsdCardLogo);
export default __webpack_public_path__ + "static/media/hsd-card-logo.f502695eaf7fc50b074d30bf0b2256c1.svg";
export { ForwardRef as ReactComponent };